import * as Sentry from "@sentry/browser";

function configureSentry() {
  let env = gon.env;
  let env_vars = gon.env_vars;

  let config = {
    dsn:          env_vars.sentry_dsn,
    release:      env_vars.version,
    environment:  env,
    debug:        env == "development"
  }

  if ((env == "development") || (env == "staging")) {
    console.log(`Sentry config`)
    console.log(config)
  };

  Sentry.init(config);
}

export default configureSentry;
